import { Icon } from "@material-ui/core";
import i18n from "i18next";
import { TemplateFilter } from "Models/Filters/TemplateFilter";
import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import ServiceProvider from "ServiceProvider/ServiceProvider";
import Types from "ServiceProvider/Types";
import { IAuditTemplateAction } from "Store/AuditTemplates/AuditTemplateAction";
import { IAuditTemplateState } from "Store/AuditTemplates/AuditTemplateState";
import { IApplicationState } from "Store/Store";
import styles from "./AuditTemplateSearch.scss";

const auditTemplateAction = ServiceProvider.get<IAuditTemplateAction>(Types.IAuditTemplateAction);

const mapDispatchToProps = (dispatch: Dispatch) => ({
    getAuditTemplatesByFilterAsync: (filter: TemplateFilter) =>
        dispatch(auditTemplateAction.getAuditTemplatesByFilterAsync(filter, true))
});

const mapStateToProps = (state: IApplicationState) => ({
    auditTemplateState: state.auditTemplateState
});

interface IProps {
    auditTemplateState: IAuditTemplateState;
    getAuditTemplatesByFilterAsync: (filter: TemplateFilter) => Action;
}

interface IState {
    auditTemplateState: IAuditTemplateState;
    query: string;
}

export class AuditTemplateSearch extends React.Component<IProps, IState> {
    private debounceTimeoutId: number;
    private DEBOUNCE_TIMEOUT: number = 500;

    constructor(props: IProps) {
        super(props);

        const currentFilter = props.auditTemplateState.currentFilter;
        this.state = {
            auditTemplateState: props.auditTemplateState,
            query: currentFilter && currentFilter.query ? props.auditTemplateState.currentFilter.query : ""
        };

        this.clearQuery = this.clearQuery.bind(this);
        this.findAuditTemplates = this.findAuditTemplates.bind(this);
        this.filterNewQuery = this.filterNewQuery.bind(this);
    }

    public clearQuery() {
        this.filterNewQuery("");
    }

    public findAuditTemplates(event: React.FormEvent<HTMLInputElement>) {
        const newQuery = event.currentTarget.value;
        this.filterNewQuery(newQuery);
    }

    private filterNewQuery(newQuery: string) {
        if (this.debounceTimeoutId) {
            window.clearTimeout(this.debounceTimeoutId);
        }
        this.setState({ query: newQuery });

        const debounceFunction = () => {
            const filter = {
                ...this.state.auditTemplateState.currentFilter,
                query: newQuery,
                skip: 0
            };
            this.props.getAuditTemplatesByFilterAsync(filter);
        };

        this.debounceTimeoutId = window.setTimeout(debounceFunction.bind(this), this.DEBOUNCE_TIMEOUT);
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState | null> {
        if (nextProps.auditTemplateState !== prevState.auditTemplateState) {
            return { auditTemplateState: nextProps.auditTemplateState };
        }
        return null;
    }

    public render() {
        return (
            <div className={styles.searchWrapper}>
                <div className={styles.icon}>
                    <Icon>search</Icon>
                </div>
                <input id="audit-searchbox" className={styles.search} type="text" placeholder={i18n.t("audits.search.placeholder")} value={this.state.query} onChange={this.findAuditTemplates} />
                {this.state.query !== "" ? <div className={styles.clear} onClick={this.clearQuery}>X</div> : null}
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AuditTemplateSearch);


// WEBPACK FOOTER //
// ./src/Components/Pages/AuditTemplateBlockOverview/AuditTemplateSearch/AuditTemplateSearch.tsx